module.exports = __webpack_public_path__ + "static/wsu-preview_925.fcd18549.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wsu-preview_925.jpg
// module id = 453
// module chunks = 35783957827783